// extracted by mini-css-extract-plugin
export default {"productGrid":"Xca-z","centerLink":"Yca-z","productSection":"Zca-z","item":"_ca-z","ctaButton":"ada-z"};